export interface User {
  userId: number;
  name: string;
  email: string;
  department: string;
  date: string;
  hours: string | null;
  checkIn: boolean;
  registrationId: number;
  transport: string;
  location: string;
  timeSlot: string;
}

export interface EventVolunteerData {
  eventId: number;
  eventName: string;
  registrations: number;
  registeredUsers: User[];
  attended: number;
  attendedUsers: User[];
  waitlisted: number;
  waitlistedUsers: User[];
}

export const volunteerEventMockData: EventVolunteerData = 
  {
    eventId: 213,
    eventName: "Test 11",
    registrations: 4,
    registeredUsers: [
      {
        userId: 1,
        name: "Vignesh Govind",
        email: "vignesh@mercedes-benz.com",
        department: "ITH/IO",
        date: "2026-03-03 08:04:41",
        hours: "10:00 AM - 4:00 PM",
        checkIn: false,
        registrationId: 224,
        transport: "Yes",
        location: "Bangalore",
        timeSlot: "02:00 PM - 03:00 PM"
      },
      {
        userId: 2,
        name: "Raghavaram Ganjikunta",
        email: "raghav@mercedes-benz.com",
        department: "ITH/IO",
        date: "2026-03-03 08:04:41",
        hours: "11:00 AM - 6:00 PM",
        checkIn: true,
        registrationId: 225,
        transport: "No",
        location: "Pune",
        timeSlot: "01:00 PM - 04:00 PM",
      },
    ],
    attended: 2,
    attendedUsers: [
      {
        userId: 3,
        name: "Anita Sharma",
        email: "anita@mercedes-benz.com",
        department: "HR",
        date: "2026-03-03 08:04:41",
        hours: "08:00 AM - 3:00 PM",
        checkIn: true,
        registrationId: 226,
        transport: "Yes",
        location: "Pune",
        timeSlot: "12:00 PM - 03:00 PM"
      },
    ],
    waitlisted: 1,
    waitlistedUsers: [
      {
        userId: 4,
        name: "Rahul Verma",
        email: "rahul@mercedes-benz.com",
        department: "Finance",
        date: "2026-03-03 08:04:41",
        hours: "11:00 AM - 6:00 PM",
        checkIn: false,
        registrationId: 227,
        transport: "Yes",
        location: "Bangalore",
        timeSlot: "10:00 AM - 05:00 PM"
      },
    ],
  };